import React from "react";
import { FaCheckCircle, FaPlus } from "react-icons/fa";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

const AboutAreaTwo = () => {
  const { t } = useTranslation();
  return (
    <>
      {/* =============== About Area Two End ===============*/}
      <div className='about-area pd-top-120 pd-bottom-120'>
        <div className='container'>
          <div className='row'>
            <div
              className='col-lg-6 mb-4 mb-lg-0 '
              data-aos='fade-right'
              data-aos-delay='100'
              data-aos-duration='1500'
            >
              <div className='about-thumb-inner'>
                <img
                  className='main-img'
                  src='assets/img/about/10.png'
                  alt='img'
                />
              </div>
            </div>
            <div
              className='col-lg-6 '
              data-aos='fade-left'
              data-aos-delay='100'
              data-aos-duration='1500'
            >
              <div className='section-title mb-0'>
                <h6 className='sub-title'>{t("about_us")}</h6>
                <h2 className='title'>
                 {t("about_area_title")}
                </h2>
                <p className='content mb-4'>
                  {t("about_area_subtitle")}
                </p>
                <div className='row'>
                  <div className='col-md-6'>
                    <ul className='single-list-inner style-check style-heading style-check mb-3'>
                      <li>
                        <FaCheckCircle /> {t("about_us_list1")}
                      </li>
                      <li>
                        <FaCheckCircle /> {t("about_us_list2")}
                      </li>
                    </ul>
                  </div>
                  <div className='col-md-6'>
                    <ul className='single-list-inner style-check style-heading style-check mb-3'>
                      <li>
                        <FaCheckCircle /> {t("about_us_list3")}
                      </li>
                      <li>
                        <FaCheckCircle /> {t("about_us_list4")}
                      </li>
                    </ul>
                  </div>
                </div>
                <p className='content'>
                {t("about_us_content")}
                </p>
                <Link className='btn btn-border-base' to='/about'>
                  {t("Discover_more")} <FaPlus />
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* =============== About Area Two End ===============*/}
    </>
  );
};

export default AboutAreaTwo;
